import { useAppSelector } from '@app/redux/hooks';
import dynamic from 'next/dynamic';
import { getOpenModal } from '../../module/selectors/getOpenModal';

export const ModalFastOrder = dynamic(() => import('./modal'), { ssr: false });

export const ConnectModalFastOrder = () => {
  const isOpen = useAppSelector(getOpenModal);
  if (!isOpen) {
    return null;
  }

  return <ModalFastOrder />;
};
